<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >
            <van-cell-group>
                <van-field
                        v-model="formData.danwei"
                        :rules="[{ required: true, message: '单位名称不能为空' }]"
                        label="单位名称"
                        input-align="right"
                        error-message-align="right"
                        left-icon="question-o"
                        @click-left-icon="onQuestion('danwei')"
                        clearable
                        placeholder="请输入单位名称"
                />
                <van-field
                        readonly
                        clickable
                        label="考级时间"
                        input-align="right"
                        error-message-align="right"
                        placeholder="请选择考级时间"
                        v-model="formData.datetitle"
                        :rules="[{ required: true, message: '请选择考级时间' }]"
                        @click="showDate = true" />

                <van-field
                        readonly
                        clickable
                        name="area"
                        :value="formData.province?formData.province+'/'+formData.city+'/'+formData.county:''"
                        input-align="right"
                        label="省市地区"
                        placeholder="点击选择省市区"
                        @click="showArea = true"
                />
                <van-popup v-model="showArea" position="bottom">
                    <van-area
                            :area-list="areaList"
                            :value="formData.area"
                            @confirm="onAreaConfirm"
                            @cancel="showArea = false"
                    />
                </van-popup>
                <van-field
                        v-model="formData.address"
                        :rules="[{ required: true, message: '请输入详细地址' }]"
                        error-message-align="right"
                        label="详细地址"
                        input-align="right"
                        clearable
                        placeholder="请输入详细地址"
                />
                <van-field
                        readonly
                        clickable
                        right-icon="arrow"
                        name="area"
                        input-align="right"
                        label="考官选择"
                        placeholder="请选择人员"
                        @click="showKaoguanPicker = true"
                />
                <div class="row">
                    <van-tag
                            v-for="(kaoguan ,index) in formData.kaoguan"
                            :key="index"
                            size="large"
                            plain
                            closeable
                            type="primary"
                            @close="formData.kaoguan.splice(index,1)"
                    > {{kaoguan.name}}
                    </van-tag>
                </div>
                <van-field
                        readonly
                        clickable
                        right-icon="arrow"
                        name="area"
                        input-align="right"
                        label="监督选择"
                        placeholder="请选择人员"
                        @click="showJianduPicker = true"
                />
                <div class="row">
                    <van-tag
                            v-for="(jiandu ,index) in formData.jiandu"
                            :key="index"
                            size="large"
                            plain
                            closeable
                            type="primary"
                            @close="formData.jiandu.splice(index,1)"
                    > {{jiandu.name}}
                    </van-tag>
                </div>
                <van-field
                        readonly
                        clickable
                        right-icon="arrow"
                        name="area"
                        input-align="right"
                        label="考级中心授权"
                        placeholder="请选择考级中心"
                        @click="showCenterPicker = true"
                />
                <div class="row">
                    <van-tag
                            v-for="(center ,index) in formData.extra_center"
                            :key="index"
                            size="large"
                            plain
                            closeable
                            type="primary"
                            @close="formData.extra_center.splice(index,1)"
                    > {{center.name}}
                    </van-tag>
                </div>
                <div class="operate-desc-left">考级点如需申报绿星级及以上星级的考级，需要获得考级中心授权</div>
                <van-field
                        v-model="formData.kaojiyaoqiu"
                        :rules="[{ required: true, message: '请输入考级要求' }]"
                        error-message-align="right"
                        label="考级要求"
                        rows="1"
                        autosize
                        type="textarea"
                        input-align="right"
                        clearable
                        placeholder="请输入考级要求"
                />
                <van-field
                        v-model="formData.zhuyishixiang"
                        :rules="[{ required: true, message: '请输入特殊说明' }]"
                        error-message-align="right"
                        label="特殊说明"
                        rows="1"
                        autosize
                        type="textarea"
                        input-align="right"
                        clearable
                        placeholder="请输入特殊说明"
                />
            </van-cell-group>

            <van-divider>费用信息
            </van-divider>
            <van-cell-group>

                <van-field
                        v-model="formData.kaoji_price1"
                        :rules="[{ required: true, message: '请输入红星级考级费用' }]"
                        error-message-align="right"
                        label="考级费【红】"
                        input-align="right"
                        clearable
                        placeholder="请输入红星级考级费"
                />
                <van-field
                        v-model="formData.kaoji_price2"
                        :rules="[{ required: true, message: '请输入橙星级考级费用' }]"
                        error-message-align="right"
                        label="考级费【橙】"
                        input-align="right"
                        clearable
                        placeholder="请输入橙星级考级费"
                />
                <van-field
                        v-model="formData.kaoji_price3"
                        :rules="[{ required: true, message: '请输入黄星级考级费用' }]"
                        error-message-align="right"
                        label="考级费【黄】"
                        input-align="right"
                        clearable
                        placeholder="请输入黄星级考级费"
                />
                <van-field
                        v-model="formData.kaoji_price4"
                        :rules="[{ required: true, message: '请输入绿星级考级费用' }]"
                        error-message-align="right"
                        label="考级费【绿】"
                        input-align="right"
                        clearable
                        placeholder="请输入绿星级考级费"
                />
                <van-field
                        v-model="formData.kaoji_price5"
                        :rules="[{ required: true, message: '请输入青星级考级费用' }]"
                        error-message-align="right"
                        label="考级费【青】"
                        input-align="right"
                        clearable
                        placeholder="请输入青星级考级费"
                />
                <van-field
                        v-model="formData.kaoji_price6"
                        :rules="[{ required: true, message: '请输入蓝星级考级费用' }]"
                        error-message-align="right"
                        label="考级费【蓝】"
                        input-align="right"
                        clearable
                        placeholder="请输入蓝星级考级费"
                />
                <van-field
                        v-model="formData.kaoji_price7"
                        :rules="[{ required: true, message: '请输入紫星级考级费用' }]"
                        error-message-align="right"
                        label="考级费【紫】"
                        input-align="right"
                        clearable
                        placeholder="请输入紫星级考级费"
                />
                <van-field
                        v-model="formData.clothes_price"
                        :rules="[{ required: true, message: '请输入考级服价格' }]"
                        error-message-align="right"
                        label="考级服价格"
                        input-align="right"
                        clearable
                        placeholder="请输入考级服价格"
                />

                <van-field
                        v-model="formData.shoes_price"
                        :rules="[{ required: true, message: '请输入考级鞋价格' }]"
                        error-message-align="right"
                        label="考级鞋价格"
                        input-align="right"
                        clearable
                        placeholder="请输入考级鞋价格"
                />


            </van-cell-group>


            <div class="savebtn">
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">保存</van-button>
            </div>
        </van-form>
        <KaoguanPicker
                :show="showKaoguanPicker"
                :limit="5"
                @onChange="onKaoguanChange"
                @onClose="showKaoguanPicker=false"
                :defaultValue="formData.kaoguan"
                @onConfirm="onKaoguanConfirm"
        ></KaoguanPicker>
        <JianduPicker
                :show="showJianduPicker"
                :limit="1"
                @onChange="onJianduChange"
                @onClose="showJianduPicker=false"
                :defaultValue="formData.jiandu"
                @onConfirm="onJianduConfirm"
        ></JianduPicker>
        <CenterPicker
                :show="showCenterPicker"
                :limit="1"
                @onChange="onCenterChange"
                @onClose="showCenterPicker=false"
                :defaultValue="formData.extra_center"
                @onConfirm="onCenterConfirm"
        ></CenterPicker>
        <van-popup v-model="showDate" position="bottom" >
        <van-datetime-picker
                @cancel="showDate =false"
                title="选择年月日"
                type="date"
                :default-date='new Date( (formData.datetitle? formData.datetitle :"" ).replace(/-/g,"/") )'
                :min-date="minDate"
                @confirm="onDateConfirm" />
        </van-popup>
    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }



    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        margin-left: 10px;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import KaoguanPicker from '@/components/picker/KaoguanPicker.vue';
    import JianduPicker from '@/components/picker/JianduPicker.vue';
    import CenterPicker from '@/components/picker/CenterPicker.vue';

    import {Cell,Field,Area,DatetimePicker,Form,Divider, CellGroup,RadioGroup,Radio,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button,Calendar} from 'vant';

    Vue.use(Cell).use(CellGroup).use(DatetimePicker).use(Calendar).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'StationApply',
        components: {
            PicUploader,
            KaoguanPicker,
            JianduPicker,
            CenterPicker,
        },
        data: function () {
            return {
                validator,
                showDate:false,
                showKaoguanPicker:false,
                showCenterPicker:false,
                showJianduPicker:false,
                saveLoading:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                row:{

                },
                minDate: new Date( new Date(new Date().toLocaleDateString()).getTime() +3600*24*15*1000), //15天后
                formData: {
                    id: 0,
                    datetitle:'',
                    areas:'',
                    kaoguan:[],
                    jiandu:[],
                    extra_center:[],
                    province:'',
                    city:'',
                    county:'',
                },
            }
        },
        filters: {},
        mounted() {
            let that = this;
            that.areaList = area;
            that.formData.id = this.$route.query.id||0;
            if(that.formData.id){
                this.fetch();
            }
          document.title = "申报星级"
            this.getSetting();
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            onDateConfirm(date){
                console.log('onDateConfirm',date);
                this.showDate = false;
                // this.formData.datetitle =  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}`
                this.formData.datetitle =  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
            },
            onKaoguanConfirm(values){
                console.log('onKaoguanConfirm',values)
                this.showKaoguanPicker = false;
                this.formData.kaoguan = [...values];
            },
            onKaoguanChange(values){
                console.log('onKaoguanChange',values)
                this.formData.kaoguan = [...values];
            },
            onJianduConfirm(values){
                console.log('onJianduConfirm',values)
                this.showJianduPicker = false;
                this.formData.jiandu = [...values];
            },
            onJianduChange(values){
                console.log('onJianduChange',values)
                this.formData.jiandu = [...values];
            },
            onCenterChange(values){
                console.log('onCenterChange',values)
                this.formData.extra_center = [...values];
            },
            onCenterConfirm(values){
                console.log('onJianduConfirm',values)
                this.showCenterPicker = false;
                this.formData.extra_center = [...values];
            },
            onAreaConfirm(values) {
                console.log(values);
                this.formData.area = values[2].code;
                this.formData.province = values[0].name;
                this.formData.city = values[1].name;
                this.formData.county = values[2].name;
                this.showArea = false;
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {

                    if (!this.formData.area) {
                        Toast('请选择地区');
                        return
                    }
                    if (this.formData.kaoguan.length<2) {
                        Toast('至少选择2个考官');
                        return
                    }
                }
                that.saveLoading = true;

                if (that.submitType =='save') {
                    that.$api.post('/api/qcxj/kaojiApplySave', that.formData, (res) => {
                        that.saveLoading = false;
                    }, (res) => {
                        Toast.fail(res.msg);
                        that.saveLoading = false;
                    })
                } else {
                    that.$api.post('/api/qcxj/kaojiApplyAdd', that.formData, (res) => {
                        that.saveLoading = false;
                        rbLink({
                            'name' : 'ExameApplyDetail',
                            'query':{
                                id: res.data.id
                            }
                        },'replace')
                    }, (res) => {
                        Toast.fail(res.msg);
                        that.saveLoading = false;
                    })
                }
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            fetch(){
                let that = this;
                that.$api.post('/api/qcxj/applydetail', {
                    id:that.formData.id
                }, (res) => {
                    that.formData = res.data;
                }, (res) => {
                    Toast.fail(res.msg);
                })
            },
            getSetting(){
                let that = this;
                that.$api.post('/api/qcxj/getSetting', {
                }, (res) => {
                    that.row = res.data;
                }, (res) => {
                    Toast.fail(res.msg);
                })
            }

        }
    }
</script>



// WEBPACK FOOTER //
// ExameApplyFormBasic.vue?dec6e27c